import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../core/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../core/services/toast.service';
import { PlatformLocation } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../core/services/http-client.service';

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.css'],
})
export class OrderStatusComponent implements OnInit {
  pendingOrderId: string;
  pendingOrder: any;
  orderStatus: string;
  finalObj: any = {};
  storeAddress: any;
  loading: boolean = false;

  constructor(
    private common: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toast: ToastService,
    private location: PlatformLocation,
    private _http: HttpClientService
  ) {
    this.storeAddress = this.common.getStorage(this.common.storeAddress);
  }

  ngOnInit(): void {
    // Extract pendingOrderId from the route parameters
    this.activatedRoute.params.subscribe((params) => {
      this.pendingOrderId = params['pendingOrderId']; // Access the parameter

      this.loadPendingOrder();
    });
  }

  loadPendingOrder(): void {
    this.loading = true;
    this.getPendingOrder(this.pendingOrderId).subscribe(
      (response) => {
        this.loading = false;
        this.pendingOrder = response.response;
        this.placeOrder(this.pendingOrder);
      },
      (error) => {
        this.loading = false;
        this.toast.error('Failed to fetch order details. Please try again.');
      }
    );
  }

  public getPendingOrder(pendingOrderId: string): Observable<any> {
    return this._http.get(`store/order-status/${pendingOrderId}`);
  }

  placeOrder(pendingOrder: any): void {
    if (
      this.pendingOrder.payMethod === 'POD' &&
      this.pendingOrder.status === 'PROCESSING'
    ) {
      this.orderStatus = 'success';
    } else if (this.pendingOrder.status === 'PROCESSING') {
      this.orderStatus = 'success';
    } else if (this.pendingOrder.status === 'FAILED') {
      this.orderStatus = 'failed';
    }
  }

  goHome(): void {
    this.router.navigateByUrl('/');
  }

  goToPage(url: string): void {
    this.router.navigateByUrl(`/${url}`);
  }

  viewDetails(e: string, tId: string): void {
    this.router.navigate([e], { queryParams: { transactionId: tId } });
  }
}
